<template>
  <div class="d-flex align-items-center">
    <!-- Condition Select -->
    <div class="d-flex flex-column mb-2 pr-4">
      <!-- <label for="condition" class="block"
        >Condition {{ index + 1 }} (required)</label
      > -->
      <label for="condition" class="block">{{ label }}</label>
      <select v-model="selectedCondition" @change="handleConditionChange"
        class="border p-2 rounded w-full mt-1 bg-gray-100" :disabled="isDisabled">
        <option value="">Select Condition</option>
        <option v-for="(option, index) in conditionOptions" :key="index" :value="option.value">{{ option.label }}
        </option>
      </select>
      <div v-if="errors[`field${index + 1}`]" class="mt-1">
        <small class="text-danger">{{ errors[`field${index + 1}`] }}</small>
      </div>
      <div></div>
    </div>

    <div class="d-flex flex-start justify-content-start">
      <!-- Gender Select -->
      <div v-if="selectedCondition === 'Gender'" class="mt-4">
        <select v-model="selectedGender" @change="handleChange" class="border p-2 rounded w-full bg-gray-100"
          :disabled="isDisabled">
          <option v-for="(gender, index) in genderOptions" :key="index" :value="gender.value">{{ gender.label }}
          </option>
        </select>
      </div>

      <!-- Age Range Inputs -->
      <div v-if="selectedCondition === 'Age'" class="">
        <div class="d-flex gap-4">
          <div class="d-flex flex-column mr-3">
            <label for="ageFrom">From</label>
            <div class="d-flex">
              <input type="number" v-model="ageFrom" @change="handleChange"
                class="border p-2 rounded w-full mt-1 form-control" style="width: 70px;" :disabled="isDisabled" />
              <label class="block mb-2 mr-3 col-form-label ml-3" for="">
                Year Old
              </label>
            </div>
          </div>
          <div class="d-flex flex-column">
            <label for="ageTo">To</label>
            <div class="d-flex">
              <input type="number" v-model="ageTo" @change="handleChange"
                class="border p-2 rounded w-full mt-1 form-control" style="width: 70px;" :disabled="isDisabled" />
              <label class="block mb-2 mr-3 col-form-label ml-3" for="">
                Year Old
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Tier Options -->
      <div v-if="selectedCondition === 'Tier'" class="d-flex  border mt-4 p-2 ">
        <div class="d-flex flex-column">
          <!-- Tier Option 1 -->
          <div class="d-flex justify-center align-items-center items-center">
            <input type="radio" v-model="selectedTierType" value="fixed" @change="resetTierValues('fixed')"
              :disabled="isDisabled" />
            <div class="ml-4">
              <div class="d-flex gap-4">
                <label v-for="(tier, index) in tierLevelOptions" :key="index" class="mr-2">
                  <input type="checkbox" :value="tier.value" v-model="tiers" @change="handleChange"
                    :disabled="selectedTierType !== 'fixed' || isDisabled" />
                  {{ tier.label }}
                </label>
              </div>
            </div>
          </div>

          <!-- Tier Option 2 -->
          <div class="d-flex justify-center align-items-center items-center">
            <input type="radio" v-model="selectedTierType" value="range" @change="resetTierValues('range')"
              :disabled="isDisabled" />
            <div class="ml-4 ">
              <div class="d-flex justify-center gap-4">
                <label class="block mb-2 mr-3 col-form-label">Point Range From
                </label>
                <input type="number" v-model="pointFrom" @change="handleChange" style="width: 70px;"
                  class="border p-2 mr-3 rounded w-full form-control"
                  :disabled="selectedTierType !== 'range' || isDisabled" />
                <div class="d-flex">
                  <label class="block mb-2 mr-3 col-form-label" for="">To
                  </label>
                  <input type="number" v-model="pointTo" @change="handleChange" style="width: 70px;"
                    class="border p-2 rounded w-full form-control"
                    :disabled="selectedTierType !== 'range' || isDisabled" />
                </div>
              </div>
            </div>
          </div>

          <!-- Tier Option 3 -->
          <div class="d-flex justify-center align-items-center items-center">
            <input type="radio" v-model="selectedTierType" value="expiry" @change="resetTierValues('expiry')"
              :disabled="isDisabled" />
            <div class="ml-4 d-flex">
              <label class="block mb-2 mr-3 col-form-label">About to Expire in</label>

              <input type="number" v-model="expiryDate" @change="handleChange" style="width: 70px;"
                class="border p-2 rounded w-full mr-3 form-control"
                :disabled="selectedTierType !== 'expiry' || isDisabled" />
              <label class="block mb-2 mr-3 col-form-label">days.</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { error } from "jquery";

export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    conditionOptions: {
      type: Array,
      default: () => ["Tier", "Gender", "Age"]
    },
    genderOptions: {
      type: Array,
      default: () => [
        { label: "All", value: 3 },
        { label: "Male", value: 1 },
        { label: "Female", value: 2 }
      ]
    },
    tierLevelOptions: {
      type: Array,
      default: () => [
        { label: "Silver", value: 1 },
        { label: "Gold", value: 2 },
        { label: "Platinum", value: 3 },
        { label: "Black", value: 4 }
      ]
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    condition: {
      type: Object,
      default: () => ({})
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "Condition 1 (required)"
    }
  },
  data() {
    return {
      selectedCondition: this.condition.field || "",
      selectedGender:
        this.condition.field === "Gender" ? this.condition.value : "",
      ageFrom:
        this.condition.field === "Age" && this.condition.value
          ? this.condition.value.from
          : "",
      ageTo:
        this.condition.field === "Age" && this.condition.value
          ? this.condition.value.to
          : "",
      selectedTierType:
        this.condition.field === "Tier" && this.condition.value.tier_level
          ? "fixed"
          : this.condition.field === "Tier" && this.condition.value.range
            ? "range"
            : this.condition.field === "Tier" && this.condition.value.expiry
              ? "expiry"
              : "",
      tiers:
        this.condition.field === "Tier" && this.condition.value.tier_level
          ? this.condition.value.tier_level
          : [],
      pointFrom:
        this.condition.field === "Tier" && this.condition.value.range
          ? this.condition.value.range.from
          : "",
      pointTo:
        this.condition.field === "Tier" && this.condition.value.range
          ? this.condition.value.range.to
          : "",
      expiryDate:
        this.condition.field === "Tier" && this.condition.value.expiry
          ? this.condition.value.expiry
          : ""
    };
  },
  watch: {
    selectedCondition(newVal) {
      if (newVal !== "Gender") this.selectedGender = "";
      if (newVal !== "Age") {
        this.ageFrom = "";
        this.ageTo = "";
      }
      if (newVal !== "Tier") {
        this.selectedTierType = "";
        this.tiers = [];
        this.pointFrom = "";
        this.pointTo = "";
        this.expiryDate = "";
      }
    }
  },
  methods: {
    handleConditionChange() {
      this.$emit("condition-change", {
        index: this.index,
        field: this.selectedCondition
      });

      this.$emit("value-change", {
        index: this.index,
        value: null
      });
    },
    handleChange() {
      let value = null;

      if (this.selectedCondition === "Gender") {
        value =
          this.selectedGender === null || this.selectedGender === ""
            ? null
            : this.selectedGender;
      } else if (this.selectedCondition === "Age") {
        value =
          this.ageFrom === null ||
            this.ageFrom === "" ||
            this.ageTo === null ||
            this.ageTo === ""
            ? null
            : { from: this.ageFrom, to: this.ageTo };
      } else if (this.selectedCondition === "Tier") {
        if (this.selectedTierType === "fixed") {
          value = this.tiers.length === 0 ? null : { tier_level: this.tiers };
        } else if (this.selectedTierType === "range") {
          value =
            this.pointFrom === null ||
              this.pointFrom === "" ||
              this.pointTo === null ||
              this.pointTo === ""
              ? null
              : { range: { from: this.pointFrom, to: this.pointTo } };
        } else if (this.selectedTierType === "expiry") {
          value =
            this.expiryDate === null || this.expiryDate === ""
              ? null
              : { expiry: this.expiryDate };
        }
      }
      if (value) {
        this.$emit("value-change", {
          index: this.index,
          value: value
        });
      }
    },

    resetTierValues(type) {
      this.tiers = [];
      this.pointFrom = "";
      this.pointTo = "";
      this.expiryDate = "";
      this.selectedTierType = type;
      this.handleChange();
    }
  }
};
</script>

<style scoped>
select,
input {
  margin-bottom: 10px;
}

input[type="radio"] {
  accent-color: #ac8400;
}

input[type="checkbox"] {
  accent-color: #ac8400;
  background-color: white;
}
</style>
